import Moment from "moment"
export default [
    {
        filterName: "dateFormat",
        func: (value) => {
            return Moment(value).format("YYYY-MM-DD HH:mm:ss")
        }
    },
    {
        filterName: "dateFormat2",
        func: (value) => {
            return Moment(value).format("YYYY/MM/DD HH:mm")
        }
    },
    {
        filterName: "dateFormat3",
        func: (value) => {
            return Moment(value).format("YYYY-MM-DD HH:mm")
        }
    },
    {
        filterName: "dateFormat4",
        func: (value) => {
            return Moment(value).format("YYYY.MM.DD HH:mm")
        }
    },
    {
        filterName: "dateFormat5",
        func: (value) => {
            return Moment(value).format("YYYY/MM/DD HH:mm:ss")
        }
    },
    {
        filterName: "dateFormat6",
        func: (value) => {
            return Moment(value).format("YYYY.MM.DD HH:mm:ss")
        }
    },
    {
        filterName: "dateNotTimeFormat",
        func: (value) => {
            return Moment(value).format("YYYY-MM-DD")
        }
    },
    {
        filterName: "dateNotTimeFormat2",
        func: (value) => {
            return Moment(value).format("YYYY/MM/DD")
        }
    },
    {
        filterName: "dateNotTimeFormat3",
        func: (value) => {
            return Moment(value).format("YYYY.MM.DD")
        }
    },
  
    {
        filterName: "thousandToFixed",
        func: (value) => {
            // 千位符
            if (!value) {
                return '0.00'
            }
            value = value.toLocaleString()
            // 没有找到小数点
            if (value.indexOf('.') === -1) {
                // 拼接
                value = value + '.00'
            } else if (value.charAt(value.indexOf('.') === value.length - 2)) {
                value = value + '0'
            }
            return value
        }
    }
]


// WEBPACK FOOTER //
// ./src/common/filter.js